import Axios from 'axios'
import { API_URL } from '@app/constants/endpoints'

const config = () => ({
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    Accept: 'application/json',
  },
})

const refreshToken = (
  token,
  clientId,
  clientSecret,
  grantType = 'refresh_token',
) => Axios.post(
  `${API_URL}/oauth/token`,
  {
    refresh_token: token,
    client_id: clientId,
    client_secret: clientSecret,
    grant_type: grantType,
  },
  config(),
)

export default {
  refreshToken,
}
